import { render, staticRenderFns } from "./turntable.vue?vue&type=template&id=5049ea94&scoped=true&"
import script from "./turntable.vue?vue&type=script&lang=js&"
export * from "./turntable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049ea94",
  null
  
)

export default component.exports